import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Box, Grid } from "@mui/material";
import React from "react";
import { GlassMagnifier } from "react-image-magnifiers";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default function ProductsImages({ gallery }) {
  const renderCustomThumbs = () => {
    const thumbList = gallery.map((product, index) => (
      <picture key={index}>
        <source data-srcSet={product.image} type="image/jpg" />
        <img
          key={product._id}
          src={`data:image/png;base64,${product}`}
          alt={product.alternativeText}
          height={"100%"}
          width={"100%"}
          style={{ objectFit: "contain" }}
        />
      </picture>
    ));

    return thumbList;
  };
  const css = `
.carousel .thumbs-wrapper{
  width:300px !important;
  overflow-x: scroll !important;
}
`;
  return (
    <Grid
      container
      spacing={2}
      style={{
        border: "2px solid #E0E0E0",
        borderRadius: "5px",
        padding: " 10px 20px ",
        marginBottom: "5px",
      }}
      className="colorTitle product-detail-container "
    >
      <div style={{ direction: "ltr", width: "inherit" }} className="div">
        <Carousel
          showStatus={false}
          showIndicators={true}
          showThumbs={true}
          autoPlay={false}
          transitionTime={500}
          swipeable={true}
          emulateTouch={true}
          renderThumbs={renderCustomThumbs}
          useKeyboardArrows={true}
          thumbWidth={60}
          preventMovementUntilSwipeScrollTolerance={true}
          swipeScrollTolerance={50}
          className="product-detail"
          // width={100}
          renderArrowPrev={(clickHandler, hasPrev) => {
            return (
              <Box
                onClick={() => {
                  clickHandler();
                }}
                className={"detailPage-prevCarosel"}
                sx={{
                  display: hasPrev ? "block !important" : "none !important",
                }}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: "25px" }} />
              </Box>
            );
          }}
          renderArrowNext={(clickHandler, hasNext) => {
            return (
              <Box
                onClick={() => {
                  clickHandler();
                }}
                className="detailPage-nextCarosel"
                sx={{
                  display: hasNext ? "block !important" : "none !important",
                }}
              >
                <ArrowForwardIosIcon sx={{ fontSize: "25px" }} />
              </Box>
            );
          }}
        >
          {gallery?.map((item) => (
            <div>
              <GlassMagnifier
                imageSrc={`data:image/png;base64,${item}`}
                imageAlt="First Slide"
                // alwaysInPlace={true}
                fillAvailableSpace={true}
                fillAlignTop={true}
                fillGapRight={20}
                fillGapBottom={30}
                fillGapTop={0}
                fillGapLeft={0}
                square={"square"}
                magnifierSize={"40%"}
                magnifierBorderColor="#e1e1e15"
              />
            </div>
          ))}
        </Carousel>
      </div>
    </Grid>
  );
}
const img = [
  {
    image: "images/PosterCheque.jpg",
  },
  {
    image: "images/PosterCheque.jpg",
  },
  {
    image: "images/PosterCheque.jpg",
  },
  {
    image: "images/PosterCheque.jpg",
  },
  {
    image: "images/PosterCheque.jpg",
  },
  {
    image: "images/PosterCheque.jpg",
  },
  {
    image: "images/PosterCheque.jpg",
  },
  {
    image: "images/PosterCheque.jpg",
  },
];
